import { usePotentialBookingFiltersContext } from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { FilterOptionsStyled } from '@/components/ListFilter/FilterOptionsStyled'

export const TypeFilter = () => {
  const { bookablePersonType, setFilters } = usePotentialBookingFiltersContext()

  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const types = ['Member', 'Lead']

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: string | null = null) => {
    setDropdownExpanded(false)
    if (val) {
      setFilters({ bookablePersonType: val })
    } else {
      setFilters({ bookablePersonType: null })
    }
  }

  const headerTitle = bookablePersonType || 'Type'

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle={headerTitle}
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!bookablePersonType}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          <li
            className={`${!bookablePersonType ? 'selected' : ''}`}
            onClick={() => changeFilter()}
            role={'presentation'}
          >
            All
          </li>
          {types.map((val, i) => (
            <li
              className={`${bookablePersonType === val ? 'selected' : ''}`}
              key={i}
              onClick={() => changeFilter(val)}
              role={'presentation'}
            >
              {val}
            </li>
          ))}
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
